import { MODALS, type ModalKey } from "./modal/modalConfig";
import { useAppModal } from "./modal/AppModalContext";

/**
 * A live service link. Clicking opens the real sandbox app in the preview
 * modal. Mono, small, amber-on-hover — the "underlined services are live" cue.
 */
export function ServiceChip({ app, className = "" }: { app: ModalKey; className?: string }) {
  const { open } = useAppModal();
  const cfg = MODALS[app];
  return (
    <button
      type="button"
      onClick={() => open(app)}
      className={`chip ${className}`}
      title={`open ${cfg.label} (sandbox demo)`}
    >
      <span aria-hidden className="text-amber">
        ▸
      </span>
      {cfg.label}
    </button>
  );
}
